/// <reference path='../../../../../common/types/window-config.d.ts' />
import * as React from 'react';
import { useState, useEffect } from 'react';
import { AuthService } from '@enginuity-common/services/authService';
import { getUrlParameter } from '@enginuity-common/utils/url';
import { Spinner } from '@enginuity-apps-ui-components/atoms';
import GenericErrorMessage from '../../components/misc/generic-error-message';
import { redirectUserForSignIn } from '@enginuity-common/utils/auth';
import { getCookie, deleteCookie } from '@enginuity-common/utils/cookies';
import * as singleSpa from 'single-spa';

export default function Callback() {
  const [error, setError] = useState<string>();

  const receivedError = getUrlParameter('error');
  if (receivedError) {
    switch (receivedError) {
      case 'login_required':
        redirectUserForSignIn();
        break;
      default:
        setError(getUrlParameter('error_description'));
    }
  }

  const [state, setState] = useState(
    getUrlParameter('state') ? getUrlParameter('state') : 'no-state'
  );
  const [stateError, setStateError] = useState(
    window.sessionStorage.getItem('stt') !== state ? 'Altered state.' : null
  );

  const authService = new AuthService({
    baseUrl: window.spConfig.authBaseUrl,
    clientId: window.spConfig.authClientId
  });

  const fetchTokenForUser = async () => {
    if (!error && !stateError) {
      try {
        const tokenData = await authService.requestToken();
        await authService.setTokens(tokenData.access_token, tokenData.id_token);
        const redirectUrl = getCookie('enginuity-auth-origin') || '/';
        deleteCookie('enginuity-auth-origin');
        singleSpa.navigateToUrl(redirectUrl);

      } catch (err) {
        setError(err.message)
      }
    }
    window.sessionStorage.removeItem('stt');
  };

  useEffect(() => {
    fetchTokenForUser();
  }, []);

  return (
    <div>
      {error || stateError ? (
        <GenericErrorMessage errorMsg={error || stateError || ""} fromUri=""></GenericErrorMessage>
      ) : (
          <Spinner active={true} />
        )}
    </div>
  );
}
